import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../controller/CourierController/CreateCourierController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";

function CreateUser({ courier, onClose, onSuccess }) {
    const { t } = useTranslation();
    const [formData, setFormData] = useState({ vc_Courier: '', mon_Charge: '' });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    useEffect(() => {
        if (courier) {
            setFormData({ vc_Courier: courier.vc_Courier, mon_Charge: courier.mon_Charge });
        } else {
            setFormData({ vc_Courier: '', mon_Charge: '' }); // Clear form data when switching to add mode
        }
    }, [courier]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleFormSubmit = (event) => {
        event.preventDefault(); // Prevent default form submission
        if (courier) {
            formData.ID = courier.PK_Courier_ID;
        } else {
            formData.ID = 0;
        }
        const redirectCallback = () => {
            navigate('/'); // Redirect to the login page
        };
        const redirectUserList = () => {
            navigate('/AdministrationSetting?saved=true');
        };
        handleSubmit(event, formData, setFormData, setErrors, () => {
            redirectCallback();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        }, () => {
            redirectUserList();
            onSuccess(); // Call onSuccess to reload data
            onClose(); // Close the modal on successful form submission
        });
    };

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade" id="courierModal" tabIndex="-1" aria-labelledby="courierModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{courier ? "Edit Courier" : "Add Courier"}</h5>
                                <button type="button" className="btn-close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "5px", "marginRight": "0px", "marginTop": "10px" }}>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Courier:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="vc_Courier" value={formData.vc_Courier} onChange={handleFieldChange} />
                                        {errors.vc_Courier && <div style={{ color: 'red' }}>{errors.vc_Courier}</div>}
                                    </div>
                                    <label htmlFor="inputText" className="col-sm-2 col-form-label">Mon Charge:</label>
                                    <div className="col-sm-4">
                                        <input type="text" className="form-control" name="mon_Charge" value={formData.mon_Charge} onChange={handleFieldChange} />
                                        {errors.mon_Charge && <div style={{ color: 'red' }}>{errors.mon_Charge}</div>}
                                    </div>
                                </div>

                            </div>
                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <i className="icofont-save" aria-hidden="true"> {courier ? " Update" : " Save"}</i>
                                </button>
                                <button className="btn btn-secondary" type="button" data-dismiss="modal" aria-label="Close">
                                    <i className="icofont-close" aria-hidden="true"> Close</i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}

export default CreateUser;